import { render, staticRenderFns } from "./preparelessonsModule.vue?vue&type=template&id=0b520fec&scoped=true"
import script from "./preparelessonsModule.vue?vue&type=script&lang=js"
export * from "./preparelessonsModule.vue?vue&type=script&lang=js"
import style0 from "./preparelessonsModule.vue?vue&type=style&index=0&id=0b520fec&prod&lang=scss&scoped=true"
import style1 from "./preparelessonsModule.vue?vue&type=style&index=1&id=0b520fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b520fec",
  null
  
)

export default component.exports